import React from 'react';
import styled from 'styled-components';
import { useImagesContext } from '../../contexts/ImagesContext';
import { DivClick, ImgClick } from '../utility';
import ImageAnimation from '../utils/ImageAnimation';
import { connect } from 'react-redux';
import { LevelNumber } from './LevelNumber';
import { LEVEL_DISPLAY } from '../../constant';
import SelectCompetitorDialog from './SelectCompetitorsDialog';
import RaceTimer from './RaceTimer';
import { PLAYER_COLOR } from './constants';
import {
  matchingSave,
  eventSave,
  getMatchingActive,
} from '../../services/matching';
import { useEffect } from 'react';
import { RemainingNumber } from './RemainingNumber ';

import receivePointFile from './sounds/receive-point.mp3';
import levelUpFile from './sounds/level-up.ogg';
import ReactSound from 'react-sound';
import { getStudent } from '../../services/student';
import { setSelectStudent } from '../../actions/student';
import { Delay } from '../../utils/delay';
import AnimationWithSound from '../utils/AnimationWithSound';

import gotoRaceRoomFile from './sounds/goto-race-room.mp3';
import saveOkFile from './sounds/save-ok.mp3';
import UIFx from 'uifx';

const saveOkSound = new UIFx(saveOkFile);

const Container = styled.div`
  position: relative;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
`;

const BackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
`;

const Back = styled(ImgClick)`
  position: absolute;
  top: 10px;
  right: 35px;
`;

const ScoreTableButton = styled(ImgClick)`
  position: absolute;
  left: 80px;
  top: 415px;
`;

const ScoreTableDialog = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
`;

const BoardImage = styled(ImgClick)`
  position: absolute;
  top: 660px;
  left: 50%;
  transform: translateX(-50%);
`;

const LevelImage = styled.img`
  position: absolute;
  left: 0px;
  bottom: 0px;
`;

const EventImage = styled.img`
  position: absolute;
  right: 100px;
  bottom: 10px;
`;

const EventInput = styled.input`
  position: absolute;
  right: 101px;
  bottom: 25px;
  width: 76px;
  height: 37px;
  font-size: 30px;
  padding: 5px;
  background-color: transparent;
  text-align: center;
  border: none;
`;

const HiddenButton = styled.div`
  position: absolute;
  width: 185px;
  height: 145px;
  top: 590px;
  right: 0px;
  // border: 1px solid red;
`;

const EventOkButton = styled(ImgClick)`
  position: absolute;
  right: 10px;
  bottom: 10px;
`;

const Player1 = styled(DivClick)`
  position: absolute;
  left: 550px;
  top: 650px;
`;

const Player1Button = styled.img`
  position: absolute;
`;

const Player2 = styled(DivClick)`
  position: absolute;
  left: 1190px;
  top: 650px;
`;

const Player2Button = styled.img`
  position: absolute;
`;

const PointNumber = styled.span`
  position: absolute;
  left: 192px;
  bottom: 8px;
  font-family: 'PSLxText';
  font-weight: bold;
  font-size: 70px;
  line-height: 0.8;
  text-align: center;
  width: 200px;
`;

const TuagomSit = styled.img`
  position: absolute;
  left: 980px;
  top: 250px;
`;

const Player1Image = styled.img`
  position: absolute;
  left: 16px;
  top: 16px;
  width: 150px;
  height: 150px;
  border-radius: 50%;
`;

const Player2Image = styled.img`
  position: absolute;
  left: 16px;
  top: 16px;
  width: 150px;
  height: 150px;
  border-radius: 50%;
`;

const RaceRoom = ({ handleBack, student, config, setSelectStudent }) => {
  const { images } = useImagesContext();
  const [isBackEffectVisible, setIsBackEffectVisible] = React.useState(false);
  const [isScoreTableVisible, setIsScoreTableVisible] = React.useState(false);
  const [selectPlayer2Visible, setSelectPlayer2Visible] = React.useState(false);
  const [selectcompetitor, setSelectCompetitor] = React.useState(null);
  const [playerColor, setPlayerColor] = React.useState(PLAYER_COLOR.BLACK);
  const [playTimerVisible, setPlayTimerVisible] = React.useState(false);
  const [displayImage, setDisplayImage] = React.useState(null);
  const [canSaveEvent, setCanSaveEvent] = React.useState(false);
  const [eventInput, setEventInput] = React.useState('');
  const [matching, setMatching] = React.useState(null);
  const [remainingDays, setRemainingDays] = React.useState(null);
  const [isTest, setIsTest] = React.useState(false);
  const [receivePoint, setReceivePoint] = React.useState(null);
  const [levelUp, setLevelUp] = React.useState(false);

  useEffect(() => {
    getMatchingActive(student.id).then((res) => {
      const matching = res.data;
      if (!matching) {
        setRemainingDays(null);
        return;
      }
      const now = new Date();
      const remainingDays = Math.ceil(
        (new Date(matching.endDate) - now) / (1000 * 60 * 60 * 24),
      );
      setRemainingDays(remainingDays);
      setMatching(matching);
    });
  }, []);

  const handleBackClick = () => {
    setIsBackEffectVisible(true);
    setTimeout(() => {
      handleBack();
      setIsBackEffectVisible(false);
    }, 10000);
  };

  const handlePlayer1Click = () => {
    if (matching === null) {
      return;
    }
    if (playerColor === PLAYER_COLOR.WHITE) {
      setSelectPlayer2Visible(true);
    } else {
      setPlayerColor(PLAYER_COLOR.WHITE);
    }
  };

  const handlePlayer2Click = () => {
    if (matching === null) {
      return;
    }
    if (playerColor === PLAYER_COLOR.BLACK) {
      setSelectPlayer2Visible(true);
    } else {
      setPlayerColor(PLAYER_COLOR.BLACK);
    }
  };

  return (
    <Container>
      <BackgroundImage src={images['race-background.jpg']} alt="background" />
      {isBackEffectVisible && (
        <AnimationWithSound
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: 1920,
            height: 1080,
            zIndex: 20,
          }}
          imageUrl={images['back-effect.png']}
          alt="back effect"
          soundFile={gotoRaceRoomFile}
          playSound={config.isMutedSound === false}
        />
      )}
      <Back src={images['back.png']} onClick={handleBackClick} />
      <ScoreTableButton
        src={images['btn-score-table.png']}
        onClick={() => {
          setIsScoreTableVisible((v) => !v);
        }}
      />
      {remainingDays !== null ? (
        <RemainingNumber value={`${remainingDays}`} />
      ) : (
        <RestImage src={images['race-room-rest.png']} />
      )}

      {isScoreTableVisible && (
        <ScoreTableDialog
          src={images['score-table-dialog.png']}
          onClick={() => {
            setIsScoreTableVisible(false);
          }}
        />
      )}
      <BoardImage
        src={images['board.png']}
        onClick={() => {
          // goto Timer screen
          if (selectcompetitor) {
            setPlayTimerVisible(true);
          }
        }}
      />
      <LevelImage src={images['level.png']} />
      <LevelNumber
        top={985}
        left={0}
        width={160}
        value={student ? LEVEL_DISPLAY[student.level] : 0}
      />
      <div>
        <PointNumber>
          {student && student.newPoint > 0
            ? // ? student.newPoint + (receivePoint || 0)
              student.newPoint
            : ''}
        </PointNumber>
      </div>
      <EventImage src={images['event.png']} />
      <EventInput
        type="number"
        placeholder=""
        value={eventInput}
        onChange={(e) => setEventInput(e.target.value)}
      />
      <HiddenButton onClick={() => setCanSaveEvent(true)} />
      <EventOkButton
        src={images['event-ok.png']}
        onClick={() => {
          if (canSaveEvent) {
            // save event
            eventSave(student.id, parseInt(eventInput)).then(async (result) => {
              setCanSaveEvent(false);
              setEventInput('');
              const receivePoint = result.data.receivePoint || 0;
              if (config.isMutedSound === false) {
                saveOkSound.play();
              }
              setDisplayImage(images['timer-saved.png']);
              await Delay(2000);
              setDisplayImage(null);
              setPlayTimerVisible(false);
              if (receivePoint > 0) {
                setReceivePoint(receivePoint);
                await Delay(3000);
                setReceivePoint(null);
                if (result.data.levelUp) {
                  setLevelUp(true);
                  await Delay(3000);
                  setLevelUp(false);
                }
                const res = await getStudent(student.id);
                setSelectStudent(res.data);
              }
            });
          }
        }}
      />
      <Player1 onClick={handlePlayer1Click}>
        <Player1Button
          src={
            images[
              `player${playerColor === PLAYER_COLOR.BLACK ? '1' : '2'}-button.png`
            ]
          }
        />
        <Player1Image
          src={
            playerColor === PLAYER_COLOR.BLACK
              ? student?.avatar
              : selectcompetitor?.avatar
          }
        />
      </Player1>
      <Player2 onClick={handlePlayer2Click}>
        <Player2Button
          src={
            images[
              `player${playerColor === PLAYER_COLOR.BLACK ? '2' : '1'}-button.png`
            ]
          }
        />
        <Player2Image
          src={
            playerColor === PLAYER_COLOR.WHITE
              ? student?.avatar
              : selectcompetitor?.avatar
          }
        />
      </Player2>
      <TuagomSit src={images['tuagom-sit.png']} />
      {selectPlayer2Visible && (
        <SelectCompetitorDialog
          student={student}
          onSelectCompetitor={(competitor, isTest) => {
            console.debug(
              'Selected competitor:',
              competitor,
              'isTest:',
              isTest,
            );
            setSelectPlayer2Visible(false);
            setSelectCompetitor(competitor);
            setIsTest(isTest);
          }}
        />
      )}
      {playTimerVisible && (
        <RaceTimer
          player={student}
          competitor={selectcompetitor}
          playerColor={playerColor}
          config={config}
          handleBack={() => setPlayTimerVisible(false)}
          handleWin={() => {
            matchingSave(student.id, selectcompetitor.id, 'win', isTest).then(
              async (result) => {
                // console.debug(result);
                if (config.isMutedSound === false) {
                  saveOkSound.play();
                }
                const receivePoint = result.data.receivePoint || 0;
                setDisplayImage(images['timer-saved.png']);
                await Delay(2000);
                setDisplayImage(null);
                setPlayTimerVisible(false);
                if (receivePoint > 0) {
                  await Delay(1000);
                  setReceivePoint(receivePoint);
                  await Delay(3000);
                  setReceivePoint(null);
                  if (result.data.levelUp) {
                    setLevelUp(true);
                    await Delay(3000);
                    setLevelUp(false);
                  }
                  const res = await getStudent(student.id);
                  setSelectStudent(res.data);
                }
              },
            );
          }}
          handleLose={() => {
            matchingSave(student.id, selectcompetitor.id, 'lose', isTest).then(
              async (result) => {
                // console.debug(result);
                if (config.isMutedSound === false) {
                  saveOkSound.play();
                }
                const receivePoint = result.data.receivePoint || 0;
                setDisplayImage(images['timer-saved.png']);
                await Delay(2000);
                setDisplayImage(null);
                setPlayTimerVisible(false);
                if (receivePoint > 0) {
                  await Delay(1000);
                  setReceivePoint(receivePoint);
                  await Delay(3000);
                  setReceivePoint(null);
                  if (result.data.levelUp) {
                    setLevelUp(true);
                    await Delay(3000);
                    setLevelUp(false);
                  }
                  const res = await getStudent(student.id);
                  setSelectStudent(res.data);
                }
              },
            );
          }}
        />
      )}
      {displayImage && <ImageCenter src={displayImage} alt="display image" />}
      {receivePoint > 0 && (
        <>
          <ImageAnimation
            imageUrl={images[`point+${receivePoint}.png`]}
            style={{
              position: 'absolute',
              left: 162,
              bottom: 0,
              width: 290,
              height: 240,
            }}
          />
          <ReactSound
            url={receivePointFile}
            playStatus={
              config.isMutedSound
                ? ReactSound.status.STOPPED
                : ReactSound.status.PLAYING
            }
            loop={false}
          />
        </>
      )}
      {levelUp && (
        <>
          <ImageAnimation
            imageUrl={images['level-up.png']}
            style={{
              position: 'absolute',
              left: (1920 - 520) / 2,
              top: (1080 - 369) / 2,
              width: 520,
              height: 369,
            }}
          />
          <ReactSound
            url={levelUpFile}
            playStatus={
              config.isMutedSound
                ? ReactSound.status.STOPPED
                : ReactSound.status.PLAYING
            }
            loop={false}
          />
        </>
      )}
    </Container>
  );
};

const ImageCenter = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const RestImage = styled.img`
  position: absolute;
  right: 0px;
  top: 292px;
`;

const mapStateToProps = ({ config, student }) => ({
  config,
  student,
});

export default connect(mapStateToProps, { setSelectStudent })(RaceRoom);
